import {SEARCH_FILTERS} from '@/src/app/constants/search';
import usePagination from '@/src/hooks/usePagination';
import DraftJobPositionsLayout from '@/src/jobPortal/clinicPositions/components/DraftJobPositionsLayout';
import useClinicPositions from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import css from '@/src/jobPortal/clinicPositions/styles/ActiveJobPositionsLayout.module.css';
import Pagination from '@/src/ui/pagination/container/PaginationContainer';

const INITIAL_SETTINGS = {
  [SEARCH_FILTERS.PER_PAGE]: '8',
  [SEARCH_FILTERS.OFFSET]: '0',
};

const DraftJobPositions = () => {
  const {draft, deletePositionWithConfirm, getPositionsList, isLoading} =
    useClinicPositions();

  const {onPageChange, query} = usePagination({
    initialSettingsPage: INITIAL_SETTINGS,
    callback: getPositionsList,
  });

  return (
    <div className={css.withPagination}>
      <div className={css.tablesWrapper}>
        <DraftJobPositionsLayout
          data={draft.data}
          onDeletePositionClick={deletePositionWithConfirm}
          isLoading={isLoading}
        />
      </div>
      <Pagination
        startPage={
          Number(query[SEARCH_FILTERS.OFFSET]) /
          Number(query[SEARCH_FILTERS.PER_PAGE])
        }
        onPageChange={onPageChange}
        totalItems={draft.totalAmount || 0}
        limitPerPage={Number(query[SEARCH_FILTERS.PER_PAGE])}
      />
    </div>
  );
};

export default DraftJobPositions;
